(function () {
  const root = document.querySelector(".store-locator-root");
  if (!root) return;

  const STORES_RAW = [
    {
      name: "INFINITY MALL",
      address:
        "Shop No. 232, 2nd Floor, Infiniti 2, Next To Raheja Palm Court, Malad Link Road, Malad (W), Mumbai - 400064",
      city: "Mumbai",
      state: "Maharashtra",
      type: "mall",
    },
    {
      name: "JAYANAGAR HIGHSTREET",
      address:
        "Shop No. 108, 3rd Block, 9th Main Road East, Jayanagar, Bangalore - 560011",
      city: "Bangalore",
      state: "Karnataka",
      type: "highstreet",
    },
    {
      name: "TREASURE ISLAND MALL",
      address:
        "Unit No. F-04, First Floor, Treasure Island, South Tukoganj, M.G. Road, Indore - 452001",
      city: "Indore",
      state: "Madhya Pradesh",
      type: "mall",
    },
    {
      name: "SEAWOODS CENTRAL MALL",
      address:
        "F-07, Seawood Grand Central Mall, Seawoods, Navi Mumbai - 400706",
      city: "Navi Mumbai",
      state: "Maharashtra",
      type: "mall",
    },
    {
      name: "PHOENIX MARKET CITY",
      address:
        "Unit No. F-13, 1st Floor, Phoenix Market City, L.B.S Marg, Kurla(W), Mumbai - 400070",
      city: "Mumbai",
      state: "Maharashtra",
      type: "mall",
    },
    {
      name: "BIG G MALL",
      address:
        "Shop No.1, Vatsalya Apartments, Opp. Big G Mall, Pajifond, Margao, Goa 403601",
      city: "Margao",
      state: "Goa",
      type: "mall",
    },
    {
      name: "RMZ MALL",
      address:
        "Shop No. 12, Level One, Rmz Galleria, Yelahanka Village, Bangalore 560064",
      city: "Bangalore",
      state: "Karnataka",
      type: "mall",
    },
    {
      name: "COMMERCIAL HIGHSTREET",
      address: "No 160, Commercial Street Bangalore, 560001",
      city: "Bangalore",
      state: "Karnataka",
      type: "highstreet",
    },
    {
      name: "VIVIANA MALL",
      address:
        "Unit No. Ff-46a, First Floor, Viviana Mall, Pokharan Road No.2, Thane West - 400606",
      city: "Thane",
      state: "Maharashtra",
      type: "mall",
    },
    {
      name: "DHARAMPETH HIGHSTREET",
      address: "Yashodham, 2, W High Ct Rd, Dharampeth, Nagpur - 440010",
      city: "Nagpur",
      state: "Maharashtra",
      type: "highstreet",
    },
    {
      name: "MALL DE GOA",
      address: "Kiosk - Ground Floor, Mall De Goa Porvorim - Goa 403521",
      city: "Porvorim",
      state: "Goa",
      type: "mall",
    },
    {
      name: "VR MALL",
      address: "Shop No. 16, First Floor Nagpur - 440003",
      city: "Nagpur",
      state: "Maharashtra",
      type: "mall",
    },
    {
      name: "FACTORY OUTLET",
      address:
        "Bagzone Lifestyles Pvt Ltd Gate No 413 & 420, Gonde Dumala, Mumbai Agra Highway, Nashik - 422403",
      city: "Nashik",
      state: "Maharashtra",
      type: "outlet",
    },
    {
      name: "KHUYATHONG HIGHSTREET",
      address: "Thangmeiband Dm College Road, Imphal, Manipur 795001",
      city: "Imphal",
      state: "Manipur",
      type: "highstreet",
    },
    {
      name: "V3S EAST CENTRE MALL",
      address:
        "Unit No. G-39, Ground Floor, V3s East Centre Mall, District Centre, Laxmi Nagar, Delhi - 110092",
      city: "Delhi",
      state: "Delhi",
      type: "mall",
    },
    {
      name: "UTKAL KANIKA GALLERIA MALL",
      address:
        "Sf-214, Utkal Kanika Galleria Mall, Kalpana Square, Bhubaneswar 751014",
      city: "Bhubaneswar",
      state: "Odisha",
      type: "mall",
    },
    {
      name: "PHOENIX MILLENNIUM MALL",
      address:
        "Unit No: S-25, Second Floor, Phoenix Mall Of The Millennium, Wakad, Pune - 411057",
      city: "Pune",
      state: "Maharashtra",
      type: "mall",
    },
    {
      name: "B ROAD SARDARPURA HIGHSTREET",
      address:
        "4th Main B Road, Opp. Suhag Jewellers, Sardarpura, Jodhpur - 331305",
      city: "Jodhpur",
      state: "Rajasthan",
      type: "highstreet",
    },
    {
      name: "TRITON MALL",
      address:
        "G-34a, Ground Floor, Triton Mall, Jhotwara Flyover, Jaipur - 302012",
      city: "Jaipur",
      state: "Rajasthan",
      type: "mall",
    },
    {
      name: "PHOENIX CITADEL MALL",
      address:
        "Unit No. F72, 1st Floor, Phoenix Citadel Mall, Village Khajrana, Indore - 452016",
      city: "Indore",
      state: "Madhya Pradesh",
      type: "mall",
    },
    {
      name: "UPPER BAZAR HIGHSTREET",
      address: "Sahid Chowk / Pustak Path, Upper Bazar, Ranchi 834001",
      city: "Ranchi",
      state: "Jharkhand",
      type: "highstreet",
    },
    {
      name: "PANCHSATI CIRCLE HIGHSTREET",
      address:
        "Opp Gupta Sales, Panchsati Circle, Sadul Ganj, Bikaner - 334001",
      city: "Bikaner",
      state: "Rajasthan",
      type: "highstreet",
    },
    {
      name: "MALHAR MALL",
      address:
        "Ground Floor, Mallhar Mall, Opp. C21 Mall, A.B Road, Vijay Nagar, Indore 452010",
      city: "Indore",
      state: "Madhya Pradesh",
      type: "mall",
    },
    {
      name: "TAPADIA MALL",
      address:
        "Ff Unit No. C-119 B, Tapadia City Centre, Badnera Road, Amravati - 444607",
      city: "Amravati",
      state: "Maharashtra",
      type: "mall",
    },
    {
      name: "CSM MALL",
      address: "Ground Floor, Csm Mall, Panchsheel Nagar, Jaipur - 305004",
      city: "Jaipur",
      state: "Rajasthan",
      type: "mall",
    },
    {
      name: "CELEBRATION MALL",
      address:
        "Unit No Sf-01, Second Floor, Nexus Celebration Mall, N.H. 08, Bhuwana, Udaipur - 313004",
      city: "Udaipur",
      state: "Rajasthan",
      type: "mall",
    },
    {
      name: "GHOD DOD HIGHSTREET",
      address:
        "Niraj Appt, Nr Pruthvi Apart, Ghod-Dod Road, Surat, Gujarat 395007",
      city: "Surat",
      state: "Gujarat",
      type: "highstreet",
    },
    {
      name: "L & T PUNJAGUTTA MALL",
      address: "Unit No L3-22, Punjagutta Mall, Punjagutta, Hyderabad 500082",
      city: "Hyderabad",
      state: "Telangana",
      type: "mall",
    },
    {
      name: "PROZONE MALL",
      address: "Api Rd, N 1, Cidco, Aurangabad - 431006",
      city: "Aurangabad",
      state: "Maharashtra",
      type: "mall",
    },
    {
      name: "SURYA TI MALL",
      address:
        "Shop No. Ug-43, Surya Ti Mall, Junwani Road, Bhilai, Dist Durg 490020",
      city: "Bhilai",
      state: "Chhattisgarh",
      type: "mall",
    },
    {
      name: "THE PALM MALL",
      address: "Shop No. 4, The Palm Mall, Tp Nagar, Korba 495677",
      city: "Korba",
      state: "Chhattisgarh",
      type: "mall",
    },
    {
      name: "LULU MALL",
      address:
        "Unit No L-009, First Floor, Lulu India Shopping Mall, Shaheed Path, Lucknow - 226030",
      city: "Lucknow",
      state: "Uttar Pradesh",
      type: "mall",
    },
    {
      name: "AVANI MALL",
      address:
        "Shop No: 45 & 46, Avani Riverside Mall, Jagat Banerjee Ghat Road, Howrah, West Bengal 711102",
      city: "Howrah",
      state: "West Bengal",
      type: "mall",
    },
    {
      name: "DIAMOND PLAZA MALL",
      address:
        "Lavie Kiosk Tf-05, Diamond Plaza Mall, 68 Jessore Road, Kolkata - 700055",
      city: "Kolkata",
      state: "West Bengal",
      type: "mall",
    },
    {
      name: "PACIFIC MALL",
      address:
        "Shlgf13, Lower Ground Floor, Pacific Mall, Nit Bus Stand, K.L. Mehta Road, Faridabad - 121001",
      city: "Faridabad",
      state: "Haryana",
      type: "mall",
    },
    {
      name: "WSM MALL",
      address:
        "Shop No 5, Ground Floor, World Square Mall, Loni Rd, Ghaziabad 201007",
      city: "Ghaziabad",
      state: "Uttar Pradesh",
      type: "mall",
    },
    {
      name: "AIRIA MALL",
      address:
        "Unit No Ff 34, First Floor, Airia Mall, Sec-68, Gurgaon, Haryana - 122018",
      city: "Gurgaon",
      state: "Haryana",
      type: "mall",
    },
    {
      name: "EVA MALL",
      address:
        "Shop No-20, First Floor, Eva The Mall, Patidar Crossing, Manjalpur, Vadodara - 390011",
      city: "Vadodara",
      state: "Gujarat",
      type: "mall",
    },
    {
      name: "PUNE AIRPORT INTERNATIONAL",
      address:
        "Lavie-4272-Kiosk, Pune International Airport, New Terminal Building, Pune 411032",
      city: "Pune",
      state: "Maharashtra",
      type: "airport",
    },
    {
      name: "PVP SQUARE MALL",
      address: "Unit No 2f-08, 2nd Floor, Pvp Square Mall, Vijayawada - 520010",
      city: "Vijayawada",
      state: "Andhra Pradesh",
      type: "mall",
    },
    {
      name: "GIP MALL",
      address:
        "Ground Floor, Gip Mall, Plot No A-2, Sector 38, Shop No 61, Noida 201301",
      city: "Noida",
      state: "Uttar Pradesh",
      type: "mall",
    },
    {
      name: "WESTEND MALL",
      address: "Unit No. Hgf-03, Westend Mall, Aundh, Pune - 411004",
      city: "Pune",
      state: "Maharashtra",
      type: "mall",
    },
    {
      name: "GOHPUR HIGHSTREET",
      address:
        "Lavie Store, Gohopur Tinali, Front Of Ramakrishna Public School, Itanagar 791111",
      city: "Itanagar",
      state: "Arunachal Pradesh",
      type: "highstreet",
    },
    {
      name: "NEHRU NAGAR HIGHSTREET",
      address:
        "Shop No 8, Ground Floor, Nehru Nagar 3, Ghaziabad, Uttar Pradesh, 201001",
      city: "Ghaziabad",
      state: "Uttar Pradesh",
      type: "highstreet",
    },
    {
      name: "SPECTRUM MALL",
      address:
        "Ground Floor 6b, Spectrum Metro Mall Phase 1, Sector 75, Noida 201301",
      city: "Noida",
      state: "Uttar Pradesh",
      type: "mall",
    },
    {
      name: "NEXUS ESPLANADE",
      address: "Nexus Esplanade, Rasulgarh, Bhubaneswar, Odisha - 751010",
      city: "Bhubaneswar",
      state: "Odisha",
      type: "mall",
    },
    {
      name: "MALL OF INDIA",
      address: "Unit No 3k4a, 2nd Floor, Mall Of India, Sec 18, Noida - 201301",
      city: "Noida",
      state: "Uttar Pradesh",
      type: "mall",
    },
    {
      name: "DSL MALL",
      address:
        "Shop No Sf022, 2nd Floor, Dsl Virtue Mall, Uppal, Hyderabad 500039",
      city: "Hyderabad",
      state: "Telangana",
      type: "mall",
    },
    {
      name: "AMBUJA MALL",
      address:
        "Unit No. Ccrp0114, First Floor, Ambuja City Centre Mall, Raipur - 492007",
      city: "Raipur",
      state: "Chhattisgarh",
      type: "mall",
    },
    {
      name: "WTP MALL",
      address: "World Trade Park, J.L.N. Marg, Malviya Nagar, Jaipur 302017",
      city: "Jaipur",
      state: "Rajasthan",
      type: "mall",
    },
    {
      name: "ORION MALL",
      address:
        "S2, 2nd Floor, Orion Mall, Mohaddipur Main Road, Gorakhpur 273008",
      city: "Gorakhpur",
      state: "Uttar Pradesh",
      type: "mall",
    },
    {
      name: "LULU MALL",
      address: "K44, 1st Floor, Lulu Mall, Thiruvananthapuram - 695021",
      city: "Thiruvananthapuram",
      state: "Kerala",
      type: "mall",
    },
    {
      name: "PHOENIX UNITED MALL",
      address:
        "Shop No S-02, Phoenix United Mall, Kanpur Road, Lucknow - 226012",
      city: "Lucknow",
      state: "Uttar Pradesh",
      type: "mall",
    },
    {
      name: "SEASONS MALL",
      address: "Unit No. G-22, Seasons Mall, Magarpatta City, Hadapsar, Pune",
      city: "Pune",
      state: "Maharashtra",
      type: "mall",
    },
    {
      name: "WAVE MALL",
      address: "C-2933, Mini Lig Rajajipuram, Lucknow, 226017",
      city: "Lucknow",
      state: "Uttar Pradesh",
      type: "mall",
    },
    {
      name: "BHARTIYA MALL",
      address:
        "No. K 03 F, First Floor, Bhartiya Mall Of Bengaluru, Thanisandra Main Road, Bangalore 560064",
      city: "Bangalore",
      state: "Karnataka",
      type: "mall",
    },
    {
      name: "LULU MALL",
      address:
        "Kiosk-07, First Floor, Mysore Deviation Road, Gopalapura, Bengaluru - 560023",
      city: "Bangalore",
      state: "Karnataka",
      type: "mall",
    },
    {
      name: "FORUM MALL",
      address:
        "Sf-K-02, Second Floor, Nexus Whitefield (Forum Mall), Whitefield, Bangalore - 560066",
      city: "Bangalore",
      state: "Karnataka",
      type: "mall",
    },
    {
      name: "DIMAPUR CIRCULAR ROAD HIGHSTREET",
      address: "Hussain Building, Circular Road, City Tower, Dimapur 797112",
      city: "Dimapur",
      state: "Nagaland",
      type: "highstreet",
    },
    {
      name: "VEGA MALL",
      address: "Vega Circle Mall, 1st Floor, Sevoke Road, Siliguri 734004",
      city: "Siliguri",
      state: "West Bengal",
      type: "mall",
    },
    {
      name: "MANI SQUARE MALL",
      address: "Shop No 119, 1st Floor, Mani Square Mall, Kolkata 700054",
      city: "Kolkata",
      state: "West Bengal",
      type: "mall",
    },
    {
      name: "NEXUS MALL",
      address: "Lower Ground -2, Gt Road, Amritsar 143001",
      city: "Amritsar",
      state: "Punjab",
      type: "mall",
    },
    {
      name: "DB MALL",
      address: "Shop No. 25, 2nd Floor, D B Mall, Gwalior - 474002",
      city: "Gwalior",
      state: "Madhya Pradesh",
      type: "mall",
    },
    {
      name: "TRP MALL",
      address:
        "Shop No 138, The Retail Park (Trp), Rajyash City, Central Bopal, Ahmedabad - 380058",
      city: "Ahmedabad",
      state: "Gujarat",
      type: "mall",
    },
    {
      name: "ELANTE MALL",
      address:
        "Second Floor, Industrial And Business Park, Phase 1, Chandigarh 160002",
      city: "Chandigarh",
      state: "Chandigarh",
      type: "mall",
    },
    {
      name: "CIVIL HOSPITAL ROAD HIGHSTREET",
      address: "Cts No 4833/11a/1, Civil Hospital Road, Belagavi - 590001",
      city: "Belagavi",
      state: "Karnataka",
      type: "highstreet",
    },
    {
      name: "PHOENIX PALASSIO",
      address:
        "Unit No So-8, 2nd Floor, Phoenix Palassio Mall, Gomti Nagar Extension, Lucknow 226010",
      city: "Lucknow",
      state: "Uttar Pradesh",
      type: "mall",
    },
    {
      name: "VEGAS MALL",
      address: "Vegas Mall, Sector 14 (North), Dwarka, New Delhi 110075",
      city: "Delhi",
      state: "Delhi",
      type: "mall",
    },
    {
      name: "PANDHARI HIGHSTREET",
      address:
        "Lic Road, Pandari, Raipur, Near Bata Showroom, Chhattisgarh - 492004",
      city: "Raipur",
      state: "Chhattisgarh",
      type: "highstreet",
    },
    {
      name: "DB MALL",
      address: "S-31, 2nd Floor, Db Mall, Arera Hills, Bhopal - 462016",
      city: "Bhopal",
      state: "Madhya Pradesh",
      type: "mall",
    },
    {
      name: "MGF MALL",
      address:
        "Unit No Gf 78 A, Ground Floor, Mgf Metropolitan, Gurgaon 122002",
      city: "Gurgaon",
      state: "Haryana",
      type: "mall",
    },
    {
      name: "SADAR HIGHSTREET",
      address:
        "Block No 10/11, Sjti Commercial Complex, Residency, Nagpur 440001",
      city: "Nagpur",
      state: "Maharashtra",
      type: "highstreet",
    },
    {
      name: "LULU MALL",
      address: "Unit No: Lg-06b, Lulu Mall, Kukatpally, Telangana 500072",
      city: "Hyderabad",
      state: "Telangana",
      type: "mall",
    },
    {
      name: "INORBIT MALL",
      address:
        "Inorbit Mall, Alembic Road, Unit No. S-18, 2nd Floor, Vadodara 390023",
      city: "Vadodara",
      state: "Gujarat",
      type: "mall",
    },
    {
      name: "CROWN MALL",
      address:
        "Lavie Kiosk, Ugf, Fun Republic Mall, Gomti Nagar, Lucknow - 226010",
      city: "Lucknow",
      state: "Uttar Pradesh",
      type: "mall",
    },
    {
      name: "CITY CENTRE MALL",
      address: "Ground Floor, Shop No 48, B2 Wing, City Centre, Bharuch 392001",
      city: "Bharuch",
      state: "Gujarat",
      type: "mall",
    },
    {
      name: "KUMAR PACIFIC MALL",
      address:
        "Shop No. Ff-05, Cts No. 42 & 43, Shankar Sheth Road, Pune - 411042",
      city: "Pune",
      state: "Maharashtra",
      type: "mall",
    },
    {
      name: "LULU MALL",
      address: "First Floor, Kf-11, Nh 47, Edapally, Kochi, Kerala 682024",
      city: "Kochi",
      state: "Kerala",
      type: "mall",
    },
    {
      name: "VR MALL",
      address: "Vr Mall, Dumas Road, Unit 1 Ga, Surat 395007",
      city: "Surat",
      state: "Gujarat",
      type: "mall",
    },
    {
      name: "ACROPOLIS MALL",
      address: "Shop No F017, 1st Floor, Acropolis Mall, Kasba, Kolkata 700107",
      city: "Kolkata",
      state: "West Bengal",
      type: "mall",
    },
    {
      name: "KOLKATA AIRPORT INTERNATIONAL",
      address:
        "Lavie Store, Netaji Subhash Chandra Bose International Airport, Dum Dum, Kolkata 700052",
      city: "Kolkata",
      state: "West Bengal",
      type: "airport",
    },
    {
      name: "FALCON MALL",
      address:
        "2nd Floor, 4/1, 3rd Cross, Shamanna Garden, Bannerghatta Road, Bengaluru 560030",
      city: "Bangalore",
      state: "Karnataka",
      type: "mall",
    },
    {
      name: "VR MALL",
      address:
        "Ugfk-02, Upper Ground Floor, K.R Puram, Mahadevpura, Bengaluru 560048",
      city: "Bangalore",
      state: "Karnataka",
      type: "mall",
    },
    {
      name: "VEGA CITY MALL",
      address:
        "Vega City Mall, No. K Sf11, Second Floor, Bannerghatta Road, Bangalore 560076",
      city: "Bangalore",
      state: "Karnataka",
      type: "mall",
    },
    {
      name: "SGS MALL",
      address: "Sgs Mall, 231, Moledina Road, Camp, Pune - 411001",
      city: "Pune",
      state: "Maharashtra",
      type: "mall",
    },
    {
      name: "KAMMANHALLI HIGHSTREET",
      address:
        "No. 418, Cmr Main Road, Hrbr Layout, Kalyan Nagar, Bangalore 560043",
      city: "Bangalore",
      state: "Karnataka",
      type: "highstreet",
    },
    {
      name: "LANGAVAL MALL",
      address: "Langval Mall Ff 113, New Bus Stand, Thanjavur 613007",
      city: "Thanjavur",
      state: "Tamil Nadu",
      type: "mall",
    },
    {
      name: "MAHAGUN METRO MALL",
      address:
        "Lavie Kiosk, Ground Floor, Mahagun Metro Mall, Vaishali, Ghaziabad 201019",
      city: "Ghaziabad",
      state: "Uttar Pradesh",
      type: "mall",
    },
    {
      name: "GALLERIA MALL",
      address: "Slotco Galleria Mall, 1st Floor, Katra",
      city: "Katra",
      state: "Jammu & Kashmir",
      type: "mall",
    },
    {
      name: "PALM WALK HIGHSTREET",
      address: "Shop No 107a, First Floor, Palm Walk, Ludhiana, Punjab 141122",
      city: "Ludhiana",
      state: "Punjab",
      type: "highstreet",
    },
    {
      name: "JUNCTION MALL",
      address: "1st Floor, Junction Mall, City Centre, Durgapur - 713216",
      city: "Durgapur",
      state: "West Bengal",
      type: "mall",
    },
    {
      name: "STAR MALL",
      address:
        "Star Mall, Jessore Road (North), Madhyamgram, Barasat, West Bengal 700129",
      city: "Barasat",
      state: "West Bengal",
      type: "mall",
    },
    {
      name: "EMERALD MALL",
      address: "Lavie Kiosk, Ground Floor, Emerald Mall, Lucknow 226012",
      city: "Lucknow",
      state: "Uttar Pradesh",
      type: "mall",
    },
    {
      name: "SOUTH AVENUE MALL",
      address: "First Floor, South Avenue Mall, Narmada Road, Jabalpur 482008",
      city: "Jabalpur",
      state: "Madhya Pradesh",
      type: "mall",
    },
    {
      name: "MANGNETO - THE MALL",
      address: "First Floor, Kiosk No-6, Mangneto The Mall, Bilaspur 495004",
      city: "Bilaspur",
      state: "Chhattisgarh",
      type: "mall",
    },
    {
      name: "GAUR CITY MALL",
      address:
        "Unit No Sf/S/18, Second Floor, Gaur City Mall, Greater Noida 201308",
      city: "Greater Noida",
      state: "Uttar Pradesh",
      type: "mall",
    },
    {
      name: "ELPRO CITY SQUARE MALL",
      address: "Lavie, Second Floor, Elpro City Square Mall, Chichwad, 411033",
      city: "Pune",
      state: "Maharashtra",
      type: "mall",
    },
    {
      name: "COUNTRYSIDE FACTORY OUTLETS",
      address:
        "Store No. 2, Countryside Factory Outlets, Gt Road, Amritsar 143001",
      city: "Amritsar",
      state: "Punjab",
      type: "outlet",
    },
    {
      name: "ANSAL PLAZA",
      address:
        "Atm-02, Ansal Plaza-1, Vaishali, Ghaziabad, Uttar Pradesh 201010",
      city: "Ghaziabad",
      state: "Uttar Pradesh",
      type: "mall",
    },
    {
      name: "FACTORY OUTLET",
      address: "Pune - Satara Rd, Katraj, Pune, Maharashtra 411046",
      city: "Pune",
      state: "Maharashtra",
      type: "outlet",
    },
    {
      name: "DN REGALIA MALL",
      address: "Ugk-01, Dn Regalia Mall, Patrapada, Bhubaneswar 751019",
      city: "Bhubaneswar",
      state: "Odisha",
      type: "mall",
    },
    {
      name: "JHV MALL",
      address: "Lane No-06, Daulatpur Road, Pandeypur, Varanasi 221002",
      city: "Varanasi",
      state: "Uttar Pradesh",
      type: "mall",
    },
    {
      name: "INORBIT MALL",
      address: "Inorbit Mall, Vashi, Kiosk K4, 1st Floor, Navi Mumbai 400705",
      city: "Navi Mumbai",
      state: "Maharashtra",
      type: "mall",
    },
    {
      name: "HSR MALL",
      address: "27th Main Road, Hsr Layout, Shop No 343/416, Bangalore 560102",
      city: "Bangalore",
      state: "Karnataka",
      type: "mall",
    },
    {
      name: "SARATH CITY MALL",
      address:
        "Third Floor 3f-K-18, Sarat City Mall, Kondapur, Hyderabad - 500084",
      city: "Hyderabad",
      state: "Telangana",
      type: "mall",
    },
    {
      name: "GARUDA MALL",
      address: "1st Floor, Commissariat Road, Magrath Rd, Bengaluru 560025",
      city: "Bangalore",
      state: "Karnataka",
      type: "mall",
    },
    {
      name: "JAMMU AIRPORT",
      address: "My Shop, Civil Airport, Jammu 181101",
      city: "Jammu",
      state: "Jammu & Kashmir",
      type: "airport",
    },
    {
      name: "XPERIA MALL",
      address:
        "Unit No. 30 & 31, 1st Floor, Lodha Xperia Mall, Palava, Thane 421204",
      city: "Thane",
      state: "Maharashtra",
      type: "mall",
    },
    {
      name: "CHENNAI AIRPORT T-1 DEPARTURE",
      address:
        "Bagzone Lifestyles Pvt Ltd, Chennai Airport T-1 Departure, Chennai 600016",
      city: "Chennai",
      state: "Tamil Nadu",
      type: "airport",
    },
    {
      name: "ORDERLY BAZAR HIGHSTREET",
      address: "Orderly Bazar, Opposite Smart Bazar, Varanasi 221002",
      city: "Varanasi",
      state: "Uttar Pradesh",
      type: "highstreet",
    },
    {
      name: "TIRUMULGIRY HIGHSTREET",
      address:
        "Plot No. A6/6, Ida Nacharam, Hyderabad Medchal, Malkajgiri 500076",
      city: "Hyderabad",
      state: "Telangana",
      type: "highstreet",
    },
    {
      name: "PHOENIX UNITED MALL",
      address:
        "Unit No-F23/24, First Floor, Phoenix United Mall, Bareilly 243122",
      city: "Bareilly",
      state: "Uttar Pradesh",
      type: "mall",
    },
    {
      name: "AS RAO NAGAR HIGHSTREET",
      address: "40-7-10a, Mogalrajapuram, Vijayawada, Andhra Pradesh 520010",
      city: "Vijayawada",
      state: "Andhra Pradesh",
      type: "highstreet",
    },
    {
      name: "LAKE MALL",
      address: "102/1, Swinhoe Lane, Kolkata 700042",
      city: "Kolkata",
      state: "West Bengal",
      type: "mall",
    },
    {
      name: "AMAYRA HIGHSTREET",
      address:
        "Shop No 70, Ropar Kurali Road, Sahibzada Ajit Singh Nagar, Punjab 140301",
      city: "SAS Nagar",
      state: "Punjab",
      type: "highstreet",
    },
    {
      name: "NEW BEL ROAD HIGHSTREET",
      address: "Shop No 16, Lg Floor, New Bel Rd, Bangalore 560094",
      city: "Bangalore",
      state: "Karnataka",
      type: "highstreet",
    },
    {
      name: "ORION MALL",
      address: "Orion Mall Panvel, Ground Floor, Omp-K11, Navi Mumbai 410206",
      city: "Navi Mumbai",
      state: "Maharashtra",
      type: "mall",
    },
    {
      name: "EXPRESS MALL",
      address:
        "Express Avenue Mall, Whites Road, 2nd Floor, Royapettah, Chennai 600014",
      city: "Chennai",
      state: "Tamil Nadu",
      type: "mall",
    },
    {
      name: "PACIFIC MALL",
      address:
        "Pacific Mall, Rajpur Rd, Jakhan, Unit No Ikugf02, Dehradun 248001",
      city: "Dehradun",
      state: "Uttarakhand",
      type: "mall",
    },
    {
      name: "PACIFIC MALL",
      address: "Pacific Mall, Nh-19, Jasola, New Delhi 110025",
      city: "Delhi",
      state: "Delhi",
      type: "mall",
    },
    {
      name: "PACIFIC MALL",
      address: "Pacific Mall, Tagore Garden, New Delhi 110018",
      city: "Delhi",
      state: "Delhi",
      type: "mall",
    },
    {
      name: "PACIFIC MALL",
      address: "Pacific Mall, Netaji Subhash Palace, New Delhi 110034",
      city: "Delhi",
      state: "Delhi",
      type: "mall",
    },
    {
      name: "R-CITY MALL",
      address:
        "R City Mall, South Wing/Phase 1, 2nd Floor, Ghatkopar (W), Mumbai 400086",
      city: "Mumbai",
      state: "Maharashtra",
      type: "mall",
    },
    {
      name: "CAPITAL MALL",
      address: "Capital Mall, Unit No Lg23, Nalasopara East, Palghar 401209",
      city: "Palghar",
      state: "Maharashtra",
      type: "mall",
    },
    {
      name: "AURUM MALL",
      address:
        "Shop No. U6, Aurum Q Parc, Ttc Industry Road, Navi Mumbai 400710",
      city: "Navi Mumbai",
      state: "Maharashtra",
      type: "mall",
    },
    {
      name: "AERO MALL",
      address: "Ff-18, 1st Floor, Aero Mall, Lohegaon, Pune 411032",
      city: "Pune",
      state: "Maharashtra",
      type: "mall",
    },
    {
      name: "MALL OF MYSORE",
      address: "Ground Floor Kiosk, Mall Of Mysore, Mysore 570010",
      city: "Mysore",
      state: "Karnataka",
      type: "mall",
    },
    {
      name: "GSM MALL",
      address:
        "Unit-1 Ground Floor, Gsm Mall, Miyapur Main Rd, Hyderabad 500049",
      city: "Hyderabad",
      state: "Telangana",
      type: "mall",
    },
    {
      name: "SRINAGAR AIRPORT",
      address: "Security Hold Area, Srinagar Airport, Badgam 190007",
      city: "Srinagar",
      state: "Jammu & Kashmir",
      type: "airport",
    },
    {
      name: "CHENNAI AIRPORT T-4",
      address: "Chennai Airport, T-4 Departure, Unit No 118, Chennai 600016",
      city: "Chennai",
      state: "Tamil Nadu",
      type: "airport",
    },
    {
      name: "ONE MALL",
      address:
        "Nexus Ahmedabad One Mall, Unit No Sk10, 2nd Floor, Ahmedabad 380054",
      city: "Ahmedabad",
      state: "Gujarat",
      type: "mall",
    },
    {
      name: "INFINITY MALL",
      address:
        "2nd Floor, Infinity Mall Andheri, Unit No 235b, Andheri West, Mumbai 400053",
      city: "Mumbai",
      state: "Maharashtra",
      type: "mall",
    },
    {
      name: "PRM MALL",
      address: "Shop No 1a, Ground Floor, Prm Centre Point Mall, Malda 732101",
      city: "Malda",
      state: "West Bengal",
      type: "mall",
    },
    {
      name: "PLUTONE MALL",
      address: "First Floor, Plutone Mall, Near Bank Colony, Rourkela 769015",
      city: "Rourkela",
      state: "Odisha",
      type: "mall",
    },
    {
      name: "NAGPUR AIRPORT",
      address: "Nagpur Domestic Airport, Security Hold Area, Nagpur 440005",
      city: "Nagpur",
      state: "Maharashtra",
      type: "airport",
    },
    {
      name: "OBEROI MALL",
      address:
        "Unit No F-30, First Floor, Oberoi Mall, Goregaon East, Mumbai 400063",
      city: "Mumbai",
      state: "Maharashtra",
      type: "mall",
    },
    {
      name: "PACIFIC MALL",
      address: "Pacific Mall, Mohkampur Khurd, Haridwar Road, Dehradun 248005",
      city: "Dehradun",
      state: "Uttarakhand",
      type: "mall",
    },
    {
      name: "INORBIT MALL",
      address: "Inorbit Mall, Madhapur, Rr District, Hyderabad 500081",
      city: "Hyderabad",
      state: "Telangana",
      type: "mall",
    },
    {
      name: "PATNA AIRPORT",
      address:
        "Departure Location D-18d, Jayprakash Narayan Intl Airport, Patna 800001",
      city: "Patna",
      state: "Bihar",
      type: "airport",
    },
    {
      name: "GVK ONE MALL",
      address: "Road No 1, Banjara Hills, Gvk One Mall, Hyderabad 500034",
      city: "Hyderabad",
      state: "Telangana",
      type: "mall",
    },
    {
      name: "NEXUS MALL",
      address:
        "Nexus Mall, Kphb Phase 6, 1st Floor, Kukatpally, Hyderabad 500072",
      city: "Hyderabad",
      state: "Telangana",
      type: "mall",
    },
    {
      name: "NEXUS VIJAYA MALL",
      address: "Nexus Vijaya Mall, Arcot Road, Vadapalani, Chennai 600026",
      city: "Chennai",
      state: "Tamil Nadu",
      type: "mall",
    },
    {
      name: "NEXUS MALL",
      address: "Hosur Road, 1st Floor, Nexus Mall, Bangalore 560095",
      city: "Bangalore",
      state: "Karnataka",
      type: "mall",
    },
    {
      name: "CITY CENTRE MALL",
      address: "City Centre Mall, Sf-N33, 2nd Floor, Mangalore 575001",
      city: "Mangalore",
      state: "Karnataka",
      type: "mall",
    },
    {
      name: "MANTRI SQUARE MALL",
      address:
        "Mantri Square Mall, Sampige Road, Malleswaram, Bangalore 560003",
      city: "Bangalore",
      state: "Karnataka",
      type: "mall",
    },
    {
      name: "NEXUS CENTRE CITY",
      address: "Ff-103, Nexus Centre City, Nazarbad, Mysuru 570010",
      city: "Mysore",
      state: "Karnataka",
      type: "mall",
    },
    {
      name: "FIZA MALL",
      address: "Fiza By Nexus Mall, Ff-K 02, Mangaluru 575001",
      city: "Mangalore",
      state: "Karnataka",
      type: "mall",
    },
    {
      name: "MEENAKSHI MALL",
      address: "Meenakshi Mall, Lavie No F022, Hulimavu, Bengaluru 560076",
      city: "Bangalore",
      state: "Karnataka",
      type: "mall",
    },
    {
      name: "GRAND SQUARE MALL",
      address: "Shop No 12a, Ground Floor, Velachery, Chennai 600042",
      city: "Chennai",
      state: "Tamil Nadu",
      type: "mall",
    },
    {
      name: "CITY CENTRE MALL",
      address:
        "City Centre Mall, Gs Road, Unit No 31, 2nd Floor, Guwahati 781005",
      city: "Guwahati",
      state: "Assam",
      type: "mall",
    },
    {
      name: "BANDRA LINKING ROAD",
      address:
        "Final Plot No 499, Shop No 13, Linking Road, Bandra West, Mumbai 400050",
      city: "Mumbai",
      state: "Maharashtra",
      type: "highstreet",
    },
    {
      name: "SHIPRA MALL",
      address:
        "Lavie Kiosk, Lower Ground Floor, North India Mall, Indirapuram, Ghaziabad 201014",
      city: "Ghaziabad",
      state: "Uttar Pradesh",
      type: "mall",
    },
    {
      name: "QUEENS ROAD HIGHSTREET",
      address:
        "Lg-19, Queens Corner, Amarpali Marg, Vaishali Nagar, Jaipur 302021",
      city: "Jaipur",
      state: "Rajasthan",
      type: "highstreet",
    },
    {
      name: "SOUTH CITY MALL",
      address:
        "375, Prince Anwar Shah Road, Unit No K303, South City Mall, Kolkata 700065",
      city: "Kolkata",
      state: "West Bengal",
      type: "mall",
    },
    {
      name: "UNITY ONE",
      address:
        "Rohini West Metro Station Complex, Unity One Rohini Mall, New Delhi 110085",
      city: "Delhi",
      state: "Delhi",
      type: "mall",
    },
    {
      name: "JUNCTION MALL",
      address: "Gateway Lakeshore, Y Junction Mall, Hyderabad 500072",
      city: "Hyderabad",
      state: "Telangana",
      type: "mall",
    },
    {
      name: "NEXUS MBD MALL",
      address: "Ferozpur Road, Nexus Mbd, Ludhiana, Punjab - 141012",
      city: "Ludhiana",
      state: "Punjab",
      type: "mall",
    },
    {
      name: "DLF MALL",
      address:
        "Dlf Mall, Unit No 127, 1st Floor, Moti Nagar, New Delhi - 110015",
      city: "Delhi",
      state: "Delhi",
      type: "mall",
    },
    {
      name: "DEHRADUN AIRPORT",
      address: "First Floor, Jolly Grant Airport, Dehradun - 248140",
      city: "Dehradun",
      state: "Uttarakhand",
      type: "airport",
    },
    {
      name: "GARIA HIGHSTREET",
      address: "U Connect, Patuli, Opp Pc Chandra Jewellers, Kolkata 700084",
      city: "Kolkata",
      state: "West Bengal",
      type: "highstreet",
    },
    {
      name: "DAK BANGLO HIGHSTREET",
      address:
        "N/8/2, Jessore Road, Barasat, Dist North 24 Pgs, Barasat 700124",
      city: "Barasat",
      state: "West Bengal",
      type: "highstreet",
    },
    {
      name: "CHIDYA MORE HIGHSTREET",
      address: "86(51), S.N. Banerjee Road, Chiriamore, Titagarh 700122",
      city: "Titagarh",
      state: "West Bengal",
      type: "highstreet",
    },
    {
      name: "LAVIE REACH AIRIA MALL",
      address:
        "First Floor, Reach Airia Mall, Ff-34, Sohna Road, Badshahpur, Gurgaon, Haryana 122001",
      city: "Gurgaon",
      state: "Haryana",
      type: "mall",
    },
    {
      name: "NAGPUR DOM AIRPORT",
      address:
        "Dr. Babasaheb Ambedkar International Airport, Security Hold Area, Sonegaon, Nagpur 440005",
      city: "Nagpur",
      state: "Maharashtra",
      type: "airport",
    },
    {
      name: "CHENNAI AIRPORT T-1 DEPARTURE",
      address: "Chennai Airport, T-1 Departure, Unit No 54 C2, Chennai 600016",
      city: "Chennai",
      state: "Tamil Nadu",
      type: "airport",
    },
    {
      name: "KOLKATA DOM-AIRPORT",
      address:
        "Flot No. C-402, Siddha Pines, Rajarahat Main Road, Kolkata 700136",
      city: "Kolkata",
      state: "West Bengal",
      type: "airport",
    },
    {
      name: "VIZAG INORBIT MALL",
      address:
        "Unit No F-28, 1st Floor, Inorbit Mall, Vizag, Andra Pradesh 530020",
      city: "Vizag",
      state: "Andhra Pradesh",
      type: "mall",
    },
    {
      name: "LUDHIANA WAVE MALL",
      address:
        "UG Floor, Wave Mall, Ludhiana, Punjab 141012",
      city: "Ludhiana",
      state: "Punjab",
      type: "mall",
    },
    {
      name: "MOHALI WALK MALL",
      address:
        "Plot No 1 & 2, Shop no S29, 2nd Floor, Sector-62, Phase 8, Sahibzada Ajit Singh Nagar, Mohali Walk Mall, Mohali, Punjab- 160062",
      city: "Mohali",
      state: "Punjab",
      type: "mall",
    },
    {
      name: "Pavilion Mall Kiosk",
      address:
        "Pavilion Mall, Shopping Mall, Kiosk,NoK-3,GroundFloor Pavilion Situated Old Session Court Road Fountaina Chowk, Ludhiana Panjab- 141001",
      city: "Ludhiana",
      state: "Punjab",
      type: "mall",
    },
    {
      name: "Logix City Centre Mall Kiosk",
      address:
        "Logix City Centre Mall, Sector 32, Kiosk, No 7, 1st Floor, Noida, Uttar Pradesh - 201301",
      city: "Noida",
      state: "Uttar Pradesh",
      type: "mall",
    },
    {
      name: "Ithum's Galleria Mall",
      address:
        "Ithum's Galleria Mall, I, Sector Alpha II 1st Floor, Greater Noida, Uttar Pradesh - 201310",
      city: "Noida",
      state: "Uttar Pradesh",
      type: "mall",
    },
    {
      name: "Silver Arc Mall",
      address:
        "Aarti Chowk, Ferozepur Road, GF-11, Silver Arc Mall, Ludhiana, Punjab - 141001",
      city: "Ludhiana",
      state: "Punjab",
      type: "mall",
    },
    {
      name: "DLF Avenue Saket Kiosk",
      address:
        "1st Floor, Near Third Wave Coffee, DLF Avenue District Centre, BTL-Lavie Kiosk, Press Enclave Road, Saket, Delhi NEW DELHI- 110017",
      city: "Delhi",
      state: "New Delhi",
      type: "outlet",
    },
    {
      name: "Infinity Space Shilong Kiosk",
      address:
        "Infinite Space, G S Road, Opposite Desire, Kiosk Number 01, SHILONG, Megalaya- 793001",
      city: "Shilong",
      state: "Megalaya",
      type: "outlet",
    },
    {
      name: "Bhumi World Factory Outlet Mall",
      address:
        "Unit no-223 A on Second Floor At Bhumi World Factory Outlet Mall At Pimplas Taluka Bhiwandi Dist Thane-421302",
      city: "Mumbai",
      state: "Maharashtra",
      type: "mall",
    },
    {
      name: "Visakhapatnam International Airport",
      address:
        "Location Domestic Depature SHA,Unit no - 25,Visakhapatnam international airport limited,Bhogapuram,Andhra Pradesh-531023",
      city: "Visakhapatnam",
      state: "Andhra Pradesh",
      type: "Airport",
    },
  ];

  const searchInput = document.getElementById("slSearchInput");
  const stateFilter = document.getElementById("slStateFilter");
  const cityFilter = document.getElementById("slCityFilter");
  const typeFilter = document.getElementById("slTypeFilter");
  const grid = document.getElementById("slStoresGrid");
  const count = document.getElementById("slCountShown");
  const empty = document.getElementById("slNoResults");
  const pagination = document.getElementById("slPagination");
  const featuredCityCards = root.querySelectorAll(
    ".store-locator-city-card[data-city]",
  );
  const resultsSection = document.getElementById("slResultsSection");
  const mapCanvas = root.querySelector('[data-store-map="true"]');
  const mapStatus = root.querySelector(".store-locator-map-status");
  const mapApiKey = mapCanvas
    ? (mapCanvas.getAttribute("data-api-key") || "").trim()
    : "";
  const mapDefaultCenter = mapCanvas
    ? (mapCanvas.getAttribute("data-default-center") || "India").trim()
    : "India";
  const mapDefaultZoom = mapCanvas
    ? parseInt(mapCanvas.getAttribute("data-default-zoom") || "5", 10)
    : 5;

  let mapInstance = null;
  let mapGeocoder = null;
  let mapInfoWindow = null;
  let mapMarkers = [];
  let mapLoadPromise = null;
  let mapUpdateToken = 0;

  const geocodeStorageKey = "store-locator-geocode-cache-v1";
  const geocodeCache = new Map();

  const perPage = parseInt(root.getAttribute("data-per-page") || "12", 10);
  let currentPage = 1;

  function setMapStatus(message, isError) {
    if (!mapStatus) return;
    mapStatus.textContent = message || "";
    mapStatus.classList.toggle("is-error", Boolean(isError));
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function hydrateGeocodeCache() {
    try {
      const raw = window.localStorage.getItem(geocodeStorageKey);
      if (!raw) return;
      const parsed = JSON.parse(raw);
      Object.keys(parsed || {}).forEach((key) => {
        const point = parsed[key];
        if (
          point &&
          typeof point.lat === "number" &&
          typeof point.lng === "number"
        ) {
          geocodeCache.set(key, point);
        }
      });
    } catch (error) {
      // Ignore cache parsing issues.
    }
  }

  function persistGeocodeCache() {
    try {
      const payload = {};
      geocodeCache.forEach((value, key) => {
        payload[key] = value;
      });
      window.localStorage.setItem(geocodeStorageKey, JSON.stringify(payload));
    } catch (error) {
      // Ignore storage quota errors.
    }
  }

  function loadGoogleMapsApi() {
    if (!mapCanvas) return Promise.resolve(null);
    if (window.google && window.google.maps) return Promise.resolve(window.google);
    if (mapLoadPromise) return mapLoadPromise;

    if (!mapApiKey) {
      setMapStatus(
        "Add Google Maps API key in Map block settings to load map pins.",
        true,
      );
      return Promise.resolve(null);
    }

    mapLoadPromise = new Promise((resolve) => {
      const scriptId = "store-locator-google-maps-sdk";
      const existing = document.getElementById(scriptId);

      const handleLoad = () => {
        if (window.google && window.google.maps) {
          resolve(window.google);
        } else {
          setMapStatus("Google Maps SDK loaded but map API is unavailable.", true);
          resolve(null);
        }
      };

      if (existing) {
        existing.addEventListener("load", handleLoad, { once: true });
        existing.addEventListener(
          "error",
          () => {
            setMapStatus("Unable to load Google Maps script.", true);
            resolve(null);
          },
          { once: true },
        );
        return;
      }

      const script = document.createElement("script");
      script.id = scriptId;
      script.async = true;
      script.defer = true;
      script.src =
        "https://maps.googleapis.com/maps/api/js?key=" +
        encodeURIComponent(mapApiKey) +
        "&loading=async";
      script.addEventListener("load", handleLoad, { once: true });
      script.addEventListener(
        "error",
        () => {
          setMapStatus("Unable to load Google Maps script.", true);
          resolve(null);
        },
        { once: true },
      );
      document.head.appendChild(script);
    });

    return mapLoadPromise;
  }

  function geocodeAddress(address) {
    if (!mapGeocoder) return Promise.resolve(null);

    return new Promise((resolve) => {
      mapGeocoder.geocode({ address }, (results, status) => {
        if (status === "OK" && results && results[0] && results[0].geometry) {
          const location = results[0].geometry.location;
          resolve({ lat: location.lat(), lng: location.lng() });
          return;
        }
        resolve(null);
      });
    });
  }

  async function resolveStoreLatLng(store) {
    const cacheKey = [store.name, store.address, store.city, store.state]
      .join("|")
      .toLowerCase();

    if (geocodeCache.has(cacheKey)) {
      return geocodeCache.get(cacheKey);
    }

    const fullAddress =
      store.address + ", " + store.city + ", " + store.state + ", India";
    let position = await geocodeAddress(fullAddress);

    if (!position) {
      position = await geocodeAddress(store.city + ", " + store.state + ", India");
    }

    if (position) {
      geocodeCache.set(cacheKey, position);
      persistGeocodeCache();
    }

    return position;
  }

  function clearMapMarkers() {
    mapMarkers.forEach((marker) => marker.setMap(null));
    mapMarkers = [];
  }

  async function ensureMapInstance() {
    if (!mapCanvas) return false;
    const googleSdk = await loadGoogleMapsApi();
    if (!googleSdk || !googleSdk.maps) return false;

    if (mapInstance) return true;

    hydrateGeocodeCache();

    mapGeocoder = new googleSdk.maps.Geocoder();
    mapInfoWindow = new googleSdk.maps.InfoWindow();
    mapInstance = new googleSdk.maps.Map(mapCanvas, {
      center: { lat: 22.9734, lng: 78.6569 },
      zoom: Number.isFinite(mapDefaultZoom) ? mapDefaultZoom : 5,
      mapTypeControl: true,
      streetViewControl: false,
      fullscreenControl: true,
    });

    if (mapDefaultCenter && mapDefaultCenter.toLowerCase() !== "india") {
      const customCenter = await geocodeAddress(mapDefaultCenter);
      if (customCenter) {
        mapInstance.setCenter(customCenter);
      }
    }

    return true;
  }

  async function updateMapPins(stores) {
    if (!mapCanvas) return;

    const token = ++mapUpdateToken;
    const mapReady = await ensureMapInstance();
    if (!mapReady || token !== mapUpdateToken) return;

    clearMapMarkers();

    if (!stores.length) {
      setMapStatus("No stores found for selected filters.", false);
      mapInstance.setCenter({ lat: 22.9734, lng: 78.6569 });
      mapInstance.setZoom(Number.isFinite(mapDefaultZoom) ? mapDefaultZoom : 5);
      return;
    }

    setMapStatus("Loading store pins on map...", false);

    const bounds = new window.google.maps.LatLngBounds();
    let pinnedCount = 0;

    for (const store of stores) {
      if (token !== mapUpdateToken) return;

      const position = await resolveStoreLatLng(store);
      if (!position) continue;

      const marker = new window.google.maps.Marker({
        map: mapInstance,
        position,
        title: "Lavie - " + store.name,
      });

      marker.addListener("click", () => {
        const mapQuery = encodeURIComponent(
          "Lavie " +
            store.name +
            " " +
            store.address +
            " " +
            store.city +
            " " +
            store.state,
        );

        mapInfoWindow.setContent(
          '<div class="store-locator-map-info">' +
            "<strong>Lavie - " +
            escapeHtml(store.name) +
            "</strong><br>" +
            escapeHtml(store.address) +
            "<br>" +
            escapeHtml(store.city) +
            ", " +
            escapeHtml(store.state) +
            '<br><a href="https://www.google.com/maps/search/?api=1&query=' +
            mapQuery +
            '" target="_blank" rel="noopener">Get Directions</a></div>',
        );
        mapInfoWindow.open({ anchor: marker, map: mapInstance });
      });

      mapMarkers.push(marker);
      bounds.extend(position);
      pinnedCount += 1;

      // Keep geocoder usage smooth to avoid hitting browser-side quota limits.
      await new Promise((resolve) => {
        window.setTimeout(resolve, 70);
      });
    }

    if (token !== mapUpdateToken) return;

    if (pinnedCount > 0) {
      mapInstance.fitBounds(bounds, 40);
      if (mapInstance.getZoom() > 12) {
        mapInstance.setZoom(12);
      }
      setMapStatus(String(pinnedCount) + " stores pinned on map.", false);
    } else {
      setMapStatus(
        "Pins could not be generated for the current filter selection.",
        true,
      );
    }
  }

  const allCities = [...new Set(STORES_RAW.map((s) => s.city))].sort();
  const allStates = [...new Set(STORES_RAW.map((s) => s.state))].sort();

  if (stateFilter) {
    allStates.forEach((state) => {
      const opt = document.createElement("option");
      opt.value = state;
      opt.textContent = state;
      stateFilter.appendChild(opt);
    });
  }

  if (cityFilter) {
    allCities.forEach((city) => {
      const opt = document.createElement("option");
      opt.value = city;
      opt.textContent = city;
      cityFilter.appendChild(opt);
    });
  }

  function initImageSliders() {
    const sliders = root.querySelectorAll(".store-locator-slider");
    if (!sliders.length) return;

    sliders.forEach((slider) => {
      const slides = Array.from(
        slider.querySelectorAll(".store-locator-slide"),
      );
      const dots = Array.from(
        slider.querySelectorAll(".store-locator-slider-dot"),
      );
      if (slides.length <= 1) return;

      const interval = parseInt(
        slider.getAttribute("data-interval") || "5000",
        10,
      );
      let currentIndex = Math.max(
        0,
        slides.findIndex((slide) => slide.classList.contains("is-active")),
      );
      let timerId = null;

      const goToSlide = (nextIndex) => {
        const safeIndex =
          ((nextIndex % slides.length) + slides.length) % slides.length;
        slides.forEach((slide, index) => {
          slide.classList.toggle("is-active", index === safeIndex);
        });
        dots.forEach((dot, index) => {
          dot.classList.toggle("is-active", index === safeIndex);
        });
        currentIndex = safeIndex;
      };

      const stopAutoplay = () => {
        if (timerId) {
          clearInterval(timerId);
          timerId = null;
        }
      };

      const startAutoplay = () => {
        stopAutoplay();
        timerId = setInterval(
          () => {
            goToSlide(currentIndex + 1);
          },
          Math.max(2500, interval),
        );
      };

      dots.forEach((dot, index) => {
        dot.addEventListener("click", () => {
          goToSlide(index);
          startAutoplay();
        });
      });

      // Arrow button navigation (desktop)
      const prevBtn = slider.querySelector(".store-locator-slider-prev");
      const nextBtn = slider.querySelector(".store-locator-slider-next");

      if (prevBtn) {
        prevBtn.addEventListener("click", () => {
          goToSlide(currentIndex - 1);
          startAutoplay();
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener("click", () => {
          goToSlide(currentIndex + 1);
          startAutoplay();
        });
      }

      // Touch/swipe navigation (mobile)
      let touchStartX = 0;
      let touchEndX = 0;
      const SWIPE_THRESHOLD = 50;

      slider.addEventListener("touchstart", (e) => {
        touchStartX = e.changedTouches[0].screenX;
        stopAutoplay();
      }, { passive: true });

      slider.addEventListener("touchend", (e) => {
        touchEndX = e.changedTouches[0].screenX;
        const diff = touchStartX - touchEndX;
        if (Math.abs(diff) > SWIPE_THRESHOLD) {
          if (diff > 0) {
            goToSlide(currentIndex + 1);  // swipe left → next
          } else {
            goToSlide(currentIndex - 1);  // swipe right → prev
          }
        }
        startAutoplay();
      });

      // Pause auto-scroll on hover (desktop)
      slider.addEventListener("mouseenter", stopAutoplay);
      slider.addEventListener("mouseleave", startAutoplay);

      goToSlide(currentIndex);
      startAutoplay();
    });
  }

  function bindFeaturedCities() {
    if (!featuredCityCards.length) return;

    featuredCityCards.forEach((card) => {
      card.addEventListener("click", function () {
        const selectedCity = (card.getAttribute("data-city") || "").trim();
        if (!selectedCity) return;

        if (searchInput) searchInput.value = selectedCity;
        if (typeFilter) typeFilter.value = "all";

        if (cityFilter) {
          const options = Array.from(cityFilter.options || []);
          const exact = options.find(
            (option) =>
              option.value.toLowerCase() === selectedCity.toLowerCase(),
          );
          cityFilter.value = exact ? exact.value : "";
        }

        currentPage = 1;
        renderStores();

        if (resultsSection) {
          resultsSection.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    });
  }

  function getFilteredStores() {
    const q = searchInput ? searchInput.value.trim().toLowerCase() : "";
    const state = stateFilter ? stateFilter.value : "";
    const city = cityFilter ? cityFilter.value : "";
    const type = typeFilter ? typeFilter.value : "all";

    const pincodeMatch = q.match(/\b\d{6}\b/);
    const searchedPincode = pincodeMatch ? parseInt(pincodeMatch[0], 10) : null;

    const extractPincode = (address) => {
      const match = String(address || "").match(/\b\d{6}\b/);
      return match ? parseInt(match[0], 10) : null;
    };

    const scoped = STORES_RAW.filter((s) => {
      const matchQ =
        !q ||
        s.name.toLowerCase().includes(q) ||
        s.address.toLowerCase().includes(q) ||
        s.city.toLowerCase().includes(q) ||
        s.state.toLowerCase().includes(q);
      const matchState = !state || s.state === state;
      const matchCity = !city || s.city === city;
      const matchType = !type || type === "all" || s.type === type;
      return matchQ && matchState && matchCity && matchType;
    });

    // If user searches with a 6-digit pincode, rank stores by nearest pincode.
    if (searchedPincode !== null) {
      const ranked = STORES_RAW.filter((s) => {
        const matchState = !state || s.state === state;
        const matchCity = !city || s.city === city;
        const matchType = !type || type === "all" || s.type === type;
        return matchState && matchCity && matchType;
      })
        .map((s) => {
          const pin = extractPincode(s.address);
          const distance =
            pin === null
              ? Number.POSITIVE_INFINITY
              : Math.abs(pin - searchedPincode);
          const samePrefix =
            pin === null
              ? 0
              : String(pin).slice(0, 3) === String(searchedPincode).slice(0, 3)
                ? 1
                : 0;
          return { ...s, __distance: distance, __samePrefix: samePrefix };
        })
        .sort((a, b) => {
          if (a.__distance === 0 && b.__distance !== 0) return -1;
          if (b.__distance === 0 && a.__distance !== 0) return 1;
          if (a.__samePrefix !== b.__samePrefix)
            return b.__samePrefix - a.__samePrefix;
          if (a.__distance !== b.__distance) return a.__distance - b.__distance;
          return a.name.localeCompare(b.name);
        })
        .map(({ __distance, __samePrefix, ...rest }) => rest);

      return ranked;
    }

    return scoped;
  }

  function renderStores() {
    if (!grid || !count || !empty || !pagination) return;

    const filtered = getFilteredStores();
    updateMapPins(filtered);
    const total = filtered.length;
    const totalPages = Math.max(1, Math.ceil(total / perPage));

    if (currentPage > totalPages) currentPage = 1;

    const start = (currentPage - 1) * perPage;
    const pageItems = filtered.slice(start, start + perPage);

    count.textContent = String(total);

    if (!total) {
      grid.innerHTML = "";
      empty.style.display = "block";
    } else {
      empty.style.display = "none";
      grid.innerHTML = pageItems
        .map((s) => {
          const query = encodeURIComponent(
            "Lavie " + s.name + " " + s.address + " " + s.city + " " + s.state,
          );
          return [
            '<article class="store-card">',
            '  <div class="store-card-head">',
            '    <h3 class="store-card-title">Lavie - ' + s.name + "</h3>",
            '    <div class="store-card-meta">' +
              s.city +
              " | " +
              s.state +
              "</div>",
            "  </div>",
            '  <div class="store-card-body">' + s.address + "</div>",
            '  <div class="store-card-actions">',
            '    <a href="https://www.google.com/maps/search/?api=1&query=' +
              query +
              '" target="_blank" rel="noopener">Get Directions</a>',
            "  </div>",
            "</article>",
          ].join("");
        })
        .join("");
    }

    renderPagination(totalPages);
  }

  function renderPagination(totalPages) {
    if (totalPages <= 1) {
      pagination.innerHTML = "";
      return;
    }

    const pages = [];
    const pushPage = (p) => {
      if (!pages.includes(p)) pages.push(p);
    };

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i += 1) pushPage(i);
    } else if (currentPage <= 3) {
      pushPage(1);
      pushPage(2);
      pushPage(3);
      pushPage(totalPages);
    } else if (currentPage >= totalPages - 2) {
      pushPage(1);
      pushPage(totalPages - 2);
      pushPage(totalPages - 1);
      pushPage(totalPages);
    } else {
      pushPage(1);
      pushPage(currentPage - 1);
      pushPage(currentPage);
      pushPage(currentPage + 1);
      pushPage(totalPages);
    }

    let html = "";
    for (let i = 0; i < pages.length; i += 1) {
      const page = pages[i];
      const prev = pages[i - 1];
      if (i > 0 && page - prev > 1) {
        html += '<span class="page-gap">...</span>';
      }

      html +=
        '<button class="' +
        (page === currentPage ? "active" : "") +
        '" data-page="' +
        page +
        '">' +
        page +
        "</button>";
    }
    pagination.innerHTML = html;
  }

  function onFilterChange() {
    currentPage = 1;
    renderStores();
  }

  if (pagination) {
    pagination.addEventListener("click", function (e) {
      const btn = e.target.closest("button[data-page]");
      if (!btn) return;
      currentPage = parseInt(btn.getAttribute("data-page"), 10);
      renderStores();
      if (resultsSection) {
        resultsSection.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
  }

  if (searchInput) searchInput.addEventListener("input", onFilterChange);
  if (stateFilter) stateFilter.addEventListener("change", onFilterChange);
  if (cityFilter) cityFilter.addEventListener("change", onFilterChange);
  if (typeFilter) typeFilter.addEventListener("change", onFilterChange);

  initImageSliders();
  bindFeaturedCities();
  renderStores();
})();
